import { METRIC_TRANSLATE } from 'constants/translate'
import { EMetric } from 'enums/common'

export const renderSingleLegend = (props: any) => {
  const { payload } = props

  const legendData = payload.reduce((acc: any[], cur: any) => {
    if (!acc.some((v) => v.value.includes(cur.value.slice(0, cur.value.length - 2)))) {
      let key
      if (cur.value.includes('actualPerform')) {
        key = EMetric.ACTUAL_PERFORMANCE
      }
      if (cur.value.includes('baseline')) {
        key = EMetric.BASE
      }
      if (cur.value.includes('target')) {
        key = EMetric.TARGET
      }

      acc.push({
        ...cur,
        label: key
      })
      return acc
    }
    return acc
  }, [])

  return (
    <ul className='flex justify-center gap-4'>
      {legendData.map((entry: any, index: number) => {
        return (
          <li key={`item-${index}`} className='flex gap-2 items-center'>
            <div
              className={'w-[0.75rem] h-[0.75rem] rounded-sm'}
              style={{
                background: entry.color
              }}
            />
            <span className='font-normal text-xs text-black-450'>
              {METRIC_TRANSLATE[entry.label as EMetric] || METRIC_TRANSLATE['ActualPerformance']}
            </span>
          </li>
        )
      })}
    </ul>
  )
}
